import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import invariant from "tiny-invariant";
import {
  Button,
  FormControl,
  Box,
  Modal,
  Paper,
  useTheme,
  Typography,
  TextField,
} from "@mui/material";
import { TreeContext } from "../tree-context";
import useStyles from "./styles";
import api from "../../../../../services/api";
import { useNotification } from "../../../../notificationProvider";
import { AttachmentRounded, FileOpenRounded } from "@mui/icons-material";

export function ImportItemModal({
  onClose,
  json,
  open,
  arquiveName,
}: {
  onClose: () => void;
  open: boolean;
  json: DashWithCardsGraphicsChildren;
  arquiveName?: string;
}) {
  const { dispatch } = useContext(TreeContext);
  const [title, setTitle] = useState("");
  const [path, setPath] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorForm, setErrorForm] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const notify = useNotification();
  useEffect(() => {
    setTitle(json?.title || "");
    setPath(json?.path || "");
  }, [json]);

  useEffect(() => {
    setErrorForm(false);
  }, [open]);

  async function handleImportPageApi(
    json: Object,
    title: string,
    path: string
  ): Promise<any> {
    try {
      setLoading(true);
      // console.log("handlePostPageApi", id, filters, title, parentId, position);
      const response = await api.post(
        "/pages/import",
        {
          json: { ...json, title, path },
          status: 2,
        }
        // { signal }
      );
      if (response.status === 200) {
        notify(null, "Página importada com sucesso", "success");
        return response.data;
      }
    } catch (error: any) {
      if (error.code && !error.response) {
        notify(error.code, error.message, "error");
      } else {
        notify(error.status, error?.response?.data.message, "error");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
    return null;
  }
  async function handleButtonSubmitDuplicate() {
    if (json.title === title && json.path === path) {
      setErrorForm(true);
      return;
    }
    if (!json) {
      notify(null, "Erro ao ler json", "error");
      return;
    }

    setErrorForm(false);
    const data = await handleImportPageApi(json, title, path);

    if (!data) {
      return;
    }
    dispatch({
      type: "create",
      itemId: data?.id,
      newItem: {
        id: data.id,
        title: data.title,
        type: "FILHO",
        status: data?.status,
        position: data?.position,
        children: [],
        isOpen: false,
      },
    });
    onClose();
  }

  function slugify(text: string): string {
    return (
      "/" +
      text
        .trim() // Remove espaços do início e do fim
        .toLowerCase() // Transforma tudo em minúsculas
        .replace(/ç/g, "c") // substitui cedilha manualmente
        .normalize("NFD") // Remove acentos
        .replace(/[\u0300-\u036f]/g, "") // Remove diacríticos (acentos etc.)
        .replace(/[^a-z0-9]+/g, "-") // Substitui qualquer caractere não alfanumérico por "-"
    );
  }
  useEffect(() => {
    setPath(slugify(title));
  }, [title]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      // Simula o clique no botão ao pressionar Enter
      buttonRef.current?.click();
    }
  };
  return (
    <Modal open={open} closeAfterTransition onClose={onClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        {/* <form onSubmit={onSubmit}> */}
        <Box sx={styles.boxHeader}>
          <Typography variant="h6">
            {"Digite um novo nome pra página importada"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <AttachmentRounded
              sx={{ color: theme.palette.text.secondary }}
              fontSize="small"
            />
            <Typography variant="body2" color="textSecondary">
              {arquiveName}
            </Typography>
          </Box>
        </Box>
        <Box sx={styles.boxContent}>
          {/* <Box display="flex" flexDirection="column" gap={2} mt={1}> */}
          {/* <FormControl fullWidth required> */}
          <TextField
            label="Título"
            variant="filled"
            name="title"
            required
            autoFocus
            onKeyDown={handleKeyDown}
            value={title}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setTitle(e.target.value)
            }
            error={errorForm}
            helperText={errorForm && "Não pode ser igual ao original"}
            // sx={styles.textField}
          />
          <TextField
            label="Path"
            variant="filled"
            name="path"
            disabled={true}
            // required
            autoFocus
            value={path}
            error={errorForm}
            helperText={errorForm && "Não pode ser igual ao original"}
            // onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            //   setPath(slugify(e.target.value))
            // }
            // sx={styles.textField}
          />
          {/* </FormControl> */}
          {/* </Box> */}
        </Box>
        <Box sx={styles.boxActions}>
          <Button onClick={onClose} variant="outlined" disabled={loading}>
            Cancelar
          </Button>
          <Button
            ref={buttonRef}
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={handleButtonSubmitDuplicate}
          >
            Adicionar
          </Button>
        </Box>
        {/* </form> */}
      </Paper>
    </Modal>
  );
}
